//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: 'ListItemAction',
  props: {
    component: {
      type: String,
      default: 'div'
    }
  }
};
export { script as default };